import { useEffect, useState } from 'react';

/**
 * Hook that detects when the user first interacts with the page
 * Listens for mousemove or touchstart events on the provided target
 *
 * @param target - The element or window to listen for interactions on
 * @returns boolean indicating whether the user has interacted with the page
 */
export function useInteractionDetection(
  target: HTMLElement | Window | null
): boolean {
  const [hasInteracted, setHasInteracted] = useState(false);

  useEffect(() => {
    if (!target || hasInteracted) {
      return;
    }

    const handleInteraction = () => {
      setHasInteracted(true);
    };

    target.addEventListener('mousemove', handleInteraction, { once: true });
    target.addEventListener('touchstart', handleInteraction, { once: true });

    return () => {
      target.removeEventListener('mousemove', handleInteraction);
      target.removeEventListener('touchstart', handleInteraction);
    };
  }, [target, hasInteracted]);

  return hasInteracted;
}
